export const index = params => {
    return window.axios.get("/api/settings", { params });
};
export const update = settings => {
    return window.axios.put("/api/settings/" + settings.id, settings);
};
